import type { PropsWithChildren } from 'react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LocationWorkplaces from 'modules/locations/components/LocationWorkplacesForms/Add'

const WorkplacesComponent = ({ children }: PropsWithChildren) => {
  return (
    <ResponsivePage.Body variant="narrow" showHeader={false}>
      {children}
      <LocationWorkplaces />
    </ResponsivePage.Body>
  )
}

export default WorkplacesComponent
